var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-main',{attrs:{"disabled":_vm.disabled,"table-data":_vm.table,"params":_vm.params,"loading":_vm.loading,"height":_vm.height},on:{"submit":_vm.handleSubmit}}),_c('p')],1)}
var staticRenderFns = []

export { render, staticRenderFns }